import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-layout-three-columns",
  "use": "icon-layout-three-columns-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" class=\"bi bi-layout-three-columns\" fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-layout-three-columns\">\r\n  <path fill-rule=\"evenodd\" d=\"M0 2.5A1.5 1.5 0 0 1 1.5 1h13A1.5 1.5 0 0 1 16 2.5v11a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 13.5v-11zM1.5 2a.5.5 0 0 0-.5.5v11a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-11a.5.5 0 0 0-.5-.5h-13z\" />\r\n  <path fill-rule=\"evenodd\" d=\"M5 15V1h1v14H5zm5 0V1h1v14h-1z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/layout-three-columns.svg
// module id = NKZD
// module chunks = 60